<template>
<div style="width:100%">
  <v-dialog v-model="dialogReasignar" persistent max-width="600">
    <v-card :color="colores.fondo">
      <v-toolbar dark :color="colores.secundario">
        <v-btn icon dark @click="cerrarVentana"><v-icon>mdi-close</v-icon></v-btn>
        <v-toolbar-title>REASIGNAR PQR</v-toolbar-title>
      </v-toolbar>
      <v-card-text class="pt-4">
        <v-row no-gutters v-if="registro !== null">
          <v-col cols="12">
            <span style="font-size:12px">PQR: <b>{{ registro.codigo }}</b> <span v-if="registro.codigo_sfc">/ {{ registro.codigo_sfc }}</span></span>
          </v-col>
          <v-col cols="12" class="pb-2">
            <span style="font-size:12px">Responsable actual: <b>{{ responsableActual }}</b></span>
          </v-col>
        </v-row>
        <v-autocomplete v-model="seleccionAsesor" label="ASESOR" :loading="objs.loadingAsesores" :items="objs.items_asesores" item-text="usuario.nombre_usuario" item-value="id_usuario" :rules="[rules.combocero]"></v-autocomplete>
        <v-textarea v-model="observacion" label="OBSERVACION (opcional)" rows="2" counter="255" auto-grow></v-textarea>
        <v-alert v-if="objs.error" dense outlined type="error" class="mb-0"><span style="font-size:12px">{{ objs.error }}</span></v-alert>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="cerrarVentana">CANCELAR</v-btn>
        <v-btn :color="colores.secundario" dark :loading="objs.loading" :disabled="seleccionAsesor === 0" @click="confirmar">REASIGNAR</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</div>
</template>

<script>
import recBandeja from '@/js/rec_bandeja.js'
import { AREA_ASESORES } from '@/js/areas.js'
export default {
  name: 'bandeja_reasignarComponent',
  mixins: [recBandeja],
  props: ['colores', 'rules', 'dialogReasignar', 'token', 'registro'],
  data: () => ({
    objs: { loading: false, loadingAsesores: false, items_asesores: [], error: '' },
    seleccionAsesor: 0,
    observacion: ''
  }),
  watch: {
    // La lista se carga al abrir el dialogo y no en created(): la bandeja se refresca
    // cada 120 segundos y no tiene sentido consultar los asesores en cada ciclo.
    token: function () {
      this.seleccionAsesor = 0
      this.observacion = ''
      this.objs.error = ''
      this.objs.items_asesores = []
      this.rec_bandeja_asesores_activos(AREA_ASESORES)
    }
  },
  computed: {
    responsableActual () {
      if (this.registro === null || !this.registro.escalamientos) { return 'SIN ASIGNAR' }
      const abiertos = this.registro.escalamientos.filter(e => e.escestado_id === 2 && e.escaladoa !== null)
      if (abiertos.length === 0) { return 'SIN ASIGNAR' }
      return abiertos.map(e => e.escaladoa.nombre_usuario + ' ' + e.escaladoa.apellido_usuario).join(', ')
    }
  },
  methods: {
    cerrarVentana () {
      this.$emit('closed_reasignar')
    },
    confirmar () {
      if (this.seleccionAsesor === 0 || this.registro === null) { return }
      this.rec_bandeja_reasignar(this.registro.id, this.seleccionAsesor, this.observacion)
    },
    // La invoca rec_bandeja_reasignar cuando el backend responde OK.
    reasignado () {
      this.$emit('reasignado')
    }
  }
}
</script>
